import {useBreakpointUp, useBreakpoint} from '@travel-frontend/core';
import {
  Skeleton as SkeletonUI,
  Stack,
  SPACING_XSMALL,
} from '@travel-frontend/ui-components';

import {HotelBox} from '@/components/HotelBox';
import {Skeleton} from '@/components/HotelBoxPlaceholder/components/Skeleton';

type Props = {
  small?: boolean;
};

export const HotelBoxPlaceholder = ({small = false}: Props) => {
  const lgUp = useBreakpointUp('lg');
  const mdOnly = useBreakpoint(['md']);

  return (
    <HotelBox
      small={small}
      messageElement={null}
      badgesElement={
        <>
          <Skeleton width={85} height={20} />
          <Skeleton width={76} height={20} />
          <Skeleton width={105} height={20} />
        </>
      }
      buttonElement={<Skeleton width={mdOnly ? 175 : undefined} height={40} />}
      galleryElement={
        <SkeletonUI
          variant="rect"
          width="100%"
          height="100%"
          aspectRatio="16 / 9"
          borderRadius={0}
        />
      }
      hotelDetailsElement={<Skeleton height={20} width={103} />}
      offerInfoElement={
        <Stack
          spacing={SPACING_XSMALL}
          alignItems={lgUp ? 'flex-end' : 'flex-start'}
        >
          <Skeleton width={90} height={16} />
          <Skeleton width={160} height={16} />
          <Skeleton width={50} height={16} />
        </Stack>
      }
      summaryElement={
        <Stack spacing={SPACING_XSMALL}>
          <Skeleton width={60} height={14} />
          <Skeleton width={250} height={22} />
          <Skeleton width={180} height={14} />
        </Stack>
      }
      priceElement={
        <Stack alignItems="flex-end" spacing={SPACING_XSMALL}>
          <Skeleton width={90} height={14} />
          <Skeleton width={100} height={22} />
          <Skeleton width={50} height={14} />
        </Stack>
      }
      ratingElement={
        <Stack direction="row" spacing={SPACING_XSMALL} alignItems="center">
          <Skeleton width={77} height={24} />
          <Skeleton width={115} height={16} />
        </Stack>
      }
      favoriteElement={<Skeleton width={24} height={24} />}
    />
  );
};
